import { render, staticRenderFns } from "./balance_details.vue?vue&type=template&id=6caec71d&"
import script from "./balance_details.vue?vue&type=script&lang=js&"
export * from "./balance_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports